import React from 'react';

import MarkdownComponent from '../../components/MarkdownComponent/MarkdownComponent';
import { useAutoScroll } from '../../hooks/useAutoScroll';

import styles from './Licenses.module.scss';

/**
 * VD Private page
 */
const Licenses = ({ licensesMd }: { licensesMd: string }) => {
  useAutoScroll('');

  return <MarkdownComponent className={styles.licenses} markdownString={licensesMd} />;
};

export default Licenses;
